import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

import { ADVANCED_BOOKING_BANNER_CONSTANTS } from './advanced-booking-banner.constants';
import { BannerBackground } from './advanced-booking-banner.interface';

@Component({
    selector: 'dcl-advanced-booking-banner',
    templateUrl: './advanced-booking-banner.component.html',
    styleUrls: ['./advanced-booking-banner.component.scss'],
})
export class AdvancedBookingBannerComponent implements OnInit, OnDestroy {
    @Input() bannerTitle: string;
    @Input() bannerSubTitle: string;
    @Input() buttonText: string;
    @Input() contextPath: string;
    @Input() ariaText: string;
    @Input() isLargeBanner: boolean;
    @Input() linkText: string;
    @Input() imageLogo: string;
    @Input() altLogo: string;
    @Input() firstGradientColor: string;
    @Input() secondGradientColor: string;
    @Input() eventNameBanner: string = '';
    @Input() eventNameButton: string = '';
    @Input() cursorDefault: boolean;
    @Output() onClickEventBanner = new EventEmitter<string>();
    @Output() onClickEventButton = new EventEmitter<string>();

    backgroundStyle: BannerBackground;
    imgStars: string;
    imgStipple: string;
    isMobile: boolean;
    styles: { name: string; value: string }[];
    mediaMatcher: MediaQueryList;
    starsPath: string = ADVANCED_BOOKING_BANNER_CONSTANTS.bannerStars;
    stipplePath = ADVANCED_BOOKING_BANNER_CONSTANTS.bannerSstipple;
    desktopBreakpoint: number = ADVANCED_BOOKING_BANNER_CONSTANTS.viewBreakpoints.desktop;
    buttonId = ADVANCED_BOOKING_BANNER_CONSTANTS.buttonId;
    starStyle: SafeStyle;

    constructor(private sanitizer: DomSanitizer) {}

    ngOnInit(): void {
        this.imgStars = `${this.contextPath}${this.starsPath}`;
        this.imgStipple = `${this.contextPath}${this.stipplePath}`;
        this.mediaMatcher = window.matchMedia(`(max-width: ${this.desktopBreakpoint}px)`);
        this.isMobile = this.mediaMatcher.matches;
        this.backgroundStyle = this.getBackgroundStyle(this.isMobile);
        this.mediaMatcher.addEventListener('change', (ev: Event) => this.sizeListener(ev));
        this.starStyle = this.sanitizer.bypassSecurityTrustStyle(`--star-image: url('${this.imgStars}')`);
    }

    /**
     * Manage the click event executed when the banner is clicked
     * Manage the click event executed when the button in the banner is clicked
     * @param event click event
     */
    onClickAllBanner(event: MouseEvent): void {
        if (event.target && ((event.target as Element).id === this.buttonId ||
            (event.target as Element).parentElement.id === this.buttonId)) {
            this.onClickEventButton.emit(this.eventNameButton);
        } else {
            this.onClickEventBanner.emit(this.eventNameBanner);
        }
    }

    /**
     * Set the background image and gradient according to colors received in the inputs and the start image.
     * @param isMobile
     */
    getBackgroundStyle(isMobile: boolean): BannerBackground {
        const direction = (this.isLargeBanner && isMobile) ? 'to bottom' : 'to right';
        const backgroundGradient = `
            linear-gradient(${direction},
            ${this.firstGradientColor},
            ${this.secondGradientColor})`;
        const backgroundStipple = `url(${this.imgStipple})`;

        return {
            banner: {
                'background-image': `${backgroundStipple}, ${backgroundGradient}`,
            },
            halfCircle: {
                'background-image': `${backgroundStipple}`,
                'background-color': `${this.firstGradientColor}`,
            },
        };
    }

    /**
     * Set the changes in thes styles according to the size of the windown
     * @param event
     */
    sizeListener(event: Event) {
        this.isMobile = (<MediaQueryListEvent>event).matches;
        this.backgroundStyle = this.getBackgroundStyle(this.isMobile);
    }

    ngOnDestroy() {
        this.mediaMatcher.removeEventListener('change', (ev: Event) => this.sizeListener(ev));
    }
}
